<template>
  <div>
    <div class="appBody">
      <div class="headBody">
        <p class="projectName">{{ project.name }}</p>
        <p class="time">{{ nowTime }}</p>
        <p class="title">项目现场管理系统</p>
        <img
          src="../../assets/image/screenImg/lefticon.png"
          alt=""
          class="lefticon"
        />
        <div class="screenclose" @click="screenclose">
          <img
            src="../../assets/image/screenImg/guanji.png"
            alt=""
            style="width: 100%; height: 100%"
          />
        </div>
        <div class="clickbutton" @mouseenter="showFun"></div>
        <div
          class="navigation"
          v-if="navigationShow"
          v-clickoutside="handleClickOutside"
        >
          <div class="lwgl" @click="tolwgl">
            <img
              src="../../assets/image/screenImg/tolw.png"
              alt=""
              class="lwgl-img"
            />

            <p>劳务管理</p>
          </div>
          <div class="aqgl" @click="toaqgl">
            <img
              src="../../assets/image/screenImg/toaq.png"
              alt=""
              class="lwgl-img"
            />

            <p>安全管理</p>
          </div>
          <div class="hjgl" @click="tohjgl">
            <img
              src="../../assets/image/screenImg/tohb.png"
              alt=""
              class="lwgl-img"
            />

            <p>环境管理</p>
          </div>
        </div>
      </div>
      <div class="maxBody">
        <router-view style="padding-top: 5.4167vw"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Clickoutside from 'element-ui/src/utils/clickoutside'

import myHttp from '../../untils/port'
import util from '../../untils/util'
import base from '../../untils/base'
export default {
  directives: { Clickoutside },
  data() {
    return {
      navigationShow: false,
      nowTime: '',

      project: {},
      projectId: util.session.get('groupId'),
      projectInfo: [
        {
          name: '项目名称：',
          // projectName: '蚌埠医学院第一附属医院心脑血管中心施工总承包项目11111111111111111111111111'
          data: '',
        },
        {
          name: '项目地址：',
          // address: '安徽省蚌埠市龙子湖区学海路与学苑路交叉路口往东11111111111111111111111111'
          data: '安徽省蚌埠市龙子湖区学海路与学苑路交叉路口往东11111111111111111111111111',
        },
        {
          name: '建设单位：',
          // buildUnit: '中建八局第三建设有限公司'
          data: '中建八局第三建设有限公司',
        },
        {
          name: '建设单位负责人：',
          // buildUnitCommander: '宋昌进	13155287307'
          data: '宋昌进	13155287307',
        },
        {
          name: '施工单位：',
          // constructionUnit: '中国建筑第八工程局有限公司'
          data: '中国建筑第八工程局有限公司',
        },
        {
          name: '项目经理：',
          // constructionUnitCommander: '宋昌进	13155287307'
          data: '宋昌进	13155287307',
        },
        {
          name: '监理单位：',
          // supervisorUnit: '宋昌进	13155287307'
          data: '宋昌进	13155287307',
        },
        {
          name: '监理工程师：',
          // supervisorUnitCommander: '宋昌进	13155287307'
          data: '宋昌进	13155287307',
        },
      ],
    }
  },
  created() {
    // this.projectId = util.session.get('groupId')
    this.getProjectInfo()
    this.getNowTime()
  },
  mounted() {},
  methods: {
    screenclose() {
      this.$router.push({
        path: '/homeAll',
      })
    },
    tolwgl() {
      this.$router.push({
        path: '/labourServices',
      })
    },
    toaqgl() {
      this.$router.push({
        path: '/screenGantryCrane',
      })
    },
    tohjgl() {
      this.$router.push({
        path: '/raise',
      })
    },

    getProjectInfo() {
      myHttp
        .getProjectById({
          id: this.projectId,
        })
        .then((res) => {
          if (res.data.code === 200) {
            console.log(res)
            this.project = res.data.data.project
          }
        })
    },
    getNowTime() {
      let speed = 1000
      let that = this
      let theNowTime = function () {
        that.nowTime = that.timeNumber()
      }
      setInterval(theNowTime, speed)
    },
    timeNumber() {
      let today = new Date()
      let date =
        today.getFullYear() +
        '-' +
        this.twoDigits(today.getMonth() + 1) +
        '-' +
        this.twoDigits(today.getDate())
      let time =
        this.twoDigits(today.getHours()) +
        ':' +
        this.twoDigits(today.getMinutes()) +
        ':' +
        this.twoDigits(today.getSeconds())
      return date + '  ' + time
    },
    twoDigits(val) {
      if (val < 10) return '0' + val
      return val
    },
    showFun() {
      this.navigationShow = true
    },
    handleClickOutside() {
      this.navigationShow = false
    },
  },
}
</script>

<style>
.appBody {
  position: relative;
}
.headBody {
  z-index: 99;
  position: absolute;
  top: 0;
  width: 100vw;
  height: 14.375vw;
  background-color: red;
  background: url('../../assets/image/screenImg/toubu.png');
  background-size: 100%;
}
.projectName {
  margin-top: 0.5208vw;
  font-family: PingFang SC;
  font-size: 1.25vw;
  font-weight: normal;
  letter-spacing: 0.1em;
  color: #c4f9ff;
}
.maxBody {
  width: 100vw;
  height: 56.25vw;
  position: absolute;
  top: 0;
  background: url('../../assets/image/screenImg/BG2.png');
  background-size: 100% 100%;
}
.time {
  font-family: lcd;
  color: #ffffff;
  position: absolute;
  top: 1vw;
  right: 4.1667vw;
  font-size: 1.25vw;
  font-weight: normal;
  letter-spacing: 0em;
}
*::-webkit-scrollbar {
  width: 0 !important;
}

* {
  -ms-overflow-style: none;
}

* {
  overflow: -moz-scrollbars-none;
}
.title {
  font-family: PingFang SC;
  position: absolute;
  top: 1.0417vw;
  left: 2.9167vw;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0em;

  color: rgba(255, 255, 255, 0.6);
}
.lefticon {
  width: 1.5625vw;
  height: 1.5625vw;
  position: absolute;
  left: 0.8333vw;
  top: 0.8333vw;
}
.screenclose {
  width: 1.4583vw;
  height: 1.4583vw;

  position: absolute;
  right: 1.4063vw;
  top: 1vw;
  cursor: pointer;
}
.navigation {
  width: 100%;
  height: 15.625vw;
  position: absolute;
  top: 4.0083vw;

  z-index: 999999999;
  position: relative;
  font-family: PingFang SC;
  font-size: 0.9375vw;
  font-weight: normal;
  letter-spacing: 0em;

  color: #ffffff;
}
.clickbutton {
  position: absolute;
  width: 10.5625vw;
  height: 3.5625vw;

  top: 3.2083vw;
  left: 45.4167vw;
}
.lwgl {
  text-align: center;
  position: absolute;
  width: 4.9583vw;
  height: 5.3646vw;

  top: 0;
  left: 48.125vw;
}
.aqgl {
  position: absolute;
  width: 4.9583vw;
  height: 5.3646vw;

  top: 1.0938vw;
  left: 55.2604vw;
}
.hjgl {
  top: 4.2188vw;
  width: 4.9583vw;
  height: 5.3646vw;

  position: absolute;
  left: 62.1182vw;
}
.lwgl-img {
  width: 4.1667vw;
  height: 4.1667vw;
}
</style>
<style scoped>
@import '../../untils/font/font.css';
</style>